<h5 class=" mb-3">
    New Message <button mat-flat-button color="primary" class="ms-5" (click)="recipients =allSalesReps">Select All</button> <button mat-flat-button color="primary"  (click)="recipients = []">Unselect All</button>
    <i class="mi mi-close float-end" [mat-dialog-close]="true"></i>
  </h5>
  
  <mat-dialog-content class="mat-typography p-2">
    <form [formGroup]="composeNewForm" (ngSubmit)="onComposeNewFormSubmit()">
      <ul class="list-inline mb-0">
        <li class="list-inline-item form-label">
          <span class="">{{'pages.Creditlinereport.To' | translate }}:</span>
        </li>
        <li class="list-inline-item form-item-container">
          <mat-form-field class="messages-chip-list w-100" appearance="generic">
            <mat-chip-list #chipList aria-label="userName selection">
              <mat-chip *ngFor="let recipient of recipients" [selectable]="selectable" [removable]="removable" (removed)="remove(recipient.userId)">
                {{ recipient.userName }} 
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
              </mat-chip>
              <input title="autoComplete"  #recipientInput formControlName="recipientsControl" [matAutocomplete]="auto" [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              />
            </mat-chip-list>
            <mat-autocomplete multiple #auto="matAutocomplete" (optionSelected)="selected($event)" [displayWith]="getUserName">
              <mat-option *ngFor="let recipient of filteredrecipients" [value]="recipient">
                {{ recipient.userName }} | {{recipient.displayName}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </li>
      </ul>
      <ul class="list-inline mb-0">
        <li class="list-inline-item form-item-container">
          <mat-form-field class="messages-chip-list w-100" appearance="generic">
            <span class="">{{'pages.placeholders.Subject' | translate }}:</span>
            <input type="text" class=" subject-text" matInput placeholder="{{'pages.placeholders.Subject' | translate }}" formControlName="subject" />
          </mat-form-field>
        </li>
      </ul>
      <ul class="list-unstyled">
        <li class="w-100">
          <mat-form-field appearance="generic" class="w-100 border-0">
            <textarea class="text-area" matInput #messageBody maxlength="500" placeholder="Type your message..." formControlName="message"></textarea>
            <!-- <mat-hint align="end" class="me-5 text-hint">{{messageBody.value.length}} / 500</mat-hint> -->
          </mat-form-field>
          <input type="file" label="" title="upload" class="upload-container attachment-blk mt-2 float-end" id="file" (change)="handleFileInput($event.target.files)"/>
          <mat-hint align="end" class="me-5 text-hint float-end char_length">{{messageBody.value.length}} / 500</mat-hint>
        </li>
      </ul>
    </form>
  </mat-dialog-content>
  <div class="form-footer">
    <mat-dialog-actions align="end">
      <button mat-stroked-button mat-dialog-close type="button" (click)="onDiscardMessage()">
        Discard<!-- <i class="mi mi-delete me-2"></i>-->
      </button>
      <button mat-raised-button color="primary" cdkFocusInitial type="submit" (click)="onComposeNewFormSubmit()">
        {{ 'pages.placeholders.SEND' | translate }}
        <!-- <i class="mi mi-send"></i> -->
      </button>
    </mat-dialog-actions>
  </div>